import React, { useState } from "react";
import PropTypes from "prop-types";
import { FaExchangeAlt } from "react-icons/fa";
import { Typography } from "components";

const Sorter = ({ loading }) => {
  const [asc, setAsc] = useState(true);
  return (
    <div
      style={{
        width: "fit-content",
        background: "#F6F8FC",
        borderRadius: "8px",
        padding: ".5rem",
      }}
      className="cursor-pointer mt-2"
    >
      <Typography
        variant="caption1"
        state="primary"
        onClick={!loading ? () => setAsc(!asc) : ""}
      >
        {asc ? "Most" : "Least"} Recent <FaExchangeAlt />
      </Typography>
    </div>
  );
};

Sorter.prototypes = {
  loading: PropTypes.bool,
};

export default Sorter;
